import React from "react";
import ReactDOM from "react-dom/client";
import Router from "./Router";
import "./styles/main.css";
import "./styles/additional-faq-styles.css";
import "./styles/additional-about-services.css";
import "./styles/additional-about.css";
import "./styles/additional-faq.css";
import "./styles/additional-hero-services.css";
import "./styles/additional-contact.css";
import "./styles/additional-footer.css";
import "./styles/additional-hero-services-updated.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);